import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ArrowUpCircle",
  "use": "icon-ArrowUpCircle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" stroke-width=\"1.5\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" id=\"icon-ArrowUpCircle\">\n  <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol